import { Datagrid, DateField, DeleteButton, FunctionField, List, SelectInput, TextField, TextInput } from 'react-admin';
import { Create, SimpleForm, FileInput, FileField, required, SelectInput as RaSelectInput, TextInput as RaTextInput } from 'react-admin';

const deviceTypeChoices = [
    { id: 'DC082', name: 'DC082' },
    { id: 'T8112B', name: 'T8112B' },
    { id: 'T8112A', name: 'T8112A' },
];

const compareOpChoices = [
    { id: '==', name: '==' },
    { id: '!=', name: '!=' },
    { id: '>', name: '>' },
    { id: '<', name: '<' },
];

const patchFilters = [
    <TextInput source="q" label="Search" alwaysOn />,
    <SelectInput source="device_type" label="Device Type" choices={deviceTypeChoices} />,
];

export const PatchList = () => (
    <List perPage={50} sort={{ field: 'created_at', order: 'DESC' }} filters={patchFilters}>
        <Datagrid>
            <TextField label="ID" source="_id" />
            <TextField label="Device Type" source="device_type" />
            <FunctionField
                label="Firmware Compare"
                render={record => `${record.fw_compare_op || ''} ${record.fw_compare_ver || ''}`.trim()}
            />
            <FunctionField
                label="Patch Compare"
                render={record => `${record.patch_compare_op || ''} ${record.patch_compare_ver || ''}`.trim()}
            />
            <TextField label="Device ID Match" source="device_id_match" />
            <TextField label="Description" source="description" />
            <TextField label="Patch Script Version" source="patch_ver" />
            <TextField label="Script Name" source="script_name" />
            <TextField label="MD5" source="md5sum" />
            <DateField label="Created At" source="created_at" showTime />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const PatchCreate = () => (
    <Create>
        <SimpleForm>
            <RaSelectInput source="device_type" choices={deviceTypeChoices} validate={required()} />
            <RaSelectInput source="fw_compare_op" label="Firmware Compare Op" choices={compareOpChoices} />
            <RaTextInput source="fw_compare_ver" label="Firmware Compare Version" />
            <RaSelectInput source="patch_compare_op" label="Patch Compare Op" choices={compareOpChoices} />
            <RaTextInput source="patch_compare_ver" label="Patch Compare Version" />
            <RaTextInput source="device_id_match" label="Device ID Match" />
            <RaTextInput source="description" label="Description" />
            <RaTextInput source="patch_ver" label="Patch Script Version" />
            <FileInput source="script_file" label="Script Upload" validate={required()}>
                <FileField source="src" title="title" />
            </FileInput>
        </SimpleForm>
    </Create>
);
